module.exports = __webpack_public_path__ + "img/avatar.8db00fb9.jpg";